export default {
  namespaced: true,
  state: () => {
    return {
      pointId: "",
    };
  },
  mutations: {
    setpointId(state, pointId) {
      state.pointId = pointId;
    },

    clearpointInfo(state) {
      // 清除Token
      state.pointId = "";
    },
  },
  actions: {},
};
